module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('component-sidebar'), _vm._v(" "), _c('div', {
    staticClass: "content-page"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('component-header'), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('component-footer')], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xl-3"
  }, [_c('div', {
    staticClass: "mini-stat clearfix bg-white"
  }, [_c('span', {
    staticClass: "mini-stat-icon bg-purple mr-0 float-right"
  }, [_c('i', {
    staticClass: "mdi mdi-basket"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mini-stat-info"
  }, [_c('span', {
    staticClass: "counter text-purple"
  }, [_vm._v("25140")]), _vm._v("\r\n                                      Total Sales\r\n                                  ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xl-3"
  }, [_c('div', {
    staticClass: "mini-stat clearfix bg-white"
  }, [_c('span', {
    staticClass: "mini-stat-icon bg-blue-grey mr-0 float-right"
  }, [_c('i', {
    staticClass: "mdi mdi-black-mesa"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mini-stat-info"
  }, [_c('span', {
    staticClass: "counter text-blue-grey"
  }, [_vm._v("65241")]), _vm._v("\r\n                                      New Orders\r\n                                  ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xl-3"
  }, [_c('div', {
    staticClass: "mini-stat clearfix bg-white"
  }, [_c('span', {
    staticClass: "mini-stat-icon bg-brown mr-0 float-right"
  }, [_c('i', {
    staticClass: "mdi mdi-buffer"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mini-stat-info"
  }, [_c('span', {
    staticClass: "counter text-brown"
  }, [_vm._v("85412")]), _vm._v("\r\n                                      New Users\r\n                                  ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xl-3"
  }, [_c('div', {
    staticClass: "mini-stat clearfix bg-white"
  }, [_c('span', {
    staticClass: "mini-stat-icon bg-teal mr-0 float-right"
  }, [_c('i', {
    staticClass: "mdi mdi-coffee"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mini-stat-info"
  }, [_c('span', {
    staticClass: "counter text-teal"
  }, [_vm._v("20544")]), _vm._v("\r\n                                      Site Visits\r\n                                  ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-3"
  }, [_c('div', {
    staticClass: "card m-b-20"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "mt-0 header-title m-b-30"
  }, [_vm._v("Recent Stock")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-warning m-t-20",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View All Data")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline row m-t-30 clearfix",
    staticStyle: {
      "display": "none"
    }
  }, [_c('li', {
    staticClass: "col-6"
  }, [_c('p', {
    staticClass: "m-b-5 font-18 font-600"
  }, [_vm._v("7,541")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Mobile Phones")])]), _vm._v(" "), _c('li', {
    staticClass: "col-6"
  }, [_c('p', {
    staticClass: "m-b-5 font-18 font-600"
  }, [_vm._v("125")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Desktops")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3"
  }, [_c('div', {
    staticClass: "card m-b-20"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "mt-0 header-title m-b-30"
  }, [_vm._v("Purchase Order")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-success m-t-20",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View All Data")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline row m-t-30 clearfix",
    staticStyle: {
      "display": "none"
    }
  }, [_c('li', {
    staticClass: "col-6"
  }, [_c('p', {
    staticClass: "m-b-5 font-18 font-600"
  }, [_vm._v("2,541")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Mobile Phones")])]), _vm._v(" "), _c('li', {
    staticClass: "col-6"
  }, [_c('p', {
    staticClass: "m-b-5 font-18 font-600"
  }, [_vm._v("874")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Desktops")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3"
  }, [_c('div', {
    staticClass: "card m-b-20"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "mt-0 header-title m-b-30"
  }, [_vm._v("Shipped Orders")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-brown m-t-20",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View All Data")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline row m-t-30 clearfix",
    staticStyle: {
      "display": "none"
    }
  }, [_c('li', {
    staticClass: "col-6"
  }, [_c('p', {
    staticClass: "m-b-5 font-18 font-600"
  }, [_vm._v("1,154")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Mobile Phones")])]), _vm._v(" "), _c('li', {
    staticClass: "col-6"
  }, [_c('p', {
    staticClass: "m-b-5 font-18 font-600"
  }, [_vm._v("89")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Desktops")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-3"
  }, [_c('div', {
    staticClass: "card m-b-20"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "mt-0 header-title m-b-30"
  }, [_vm._v("Cancelled Orders")]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-blue-grey m-t-20",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("View All Data")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline row m-t-30 clearfix",
    staticStyle: {
      "display": "none"
    }
  }, [_c('li', {
    staticClass: "col-6"
  }, [_c('p', {
    staticClass: "m-b-5 font-18 font-600"
  }, [_vm._v("95")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Mobile Phones")])]), _vm._v(" "), _c('li', {
    staticClass: "col-6"
  }, [_c('p', {
    staticClass: "m-b-5 font-18 font-600"
  }, [_vm._v("25")]), _vm._v(" "), _c('p', {
    staticClass: "mb-0"
  }, [_vm._v("Desktops")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-6"
  }, [_c('div', {
    staticClass: "card m-b-20"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "mt-0 m-b-30 header-title"
  }, [_vm._v("Latest Transactions")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-vertical mb-0"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('img', {
    staticClass: "thumb-sm rounded-circle mr-2",
    attrs: {
      "src": "/static/assets/images/users/avatar-2.jpg",
      "alt": "user-image"
    }
  }), _vm._v("\r\n                                                      Okey Okolo\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "mdi mdi-checkbox-blank-circle text-success"
  }), _vm._v(" Confirm")]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      ₦14,584\r\n                                                      "), _c('p', {
    staticClass: "m-0 text-muted font-14"
  }, [_vm._v("Amount")])]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      5/12/2019\r\n                                                      "), _c('p', {
    staticClass: "m-0 text-muted font-14"
  }, [_vm._v("Date")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-secondary btn-sm waves-effect",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    staticClass: "thumb-sm rounded-circle mr-2",
    attrs: {
      "src": "/static/assets/images/users/avatar-3.jpg",
      "alt": "user-image"
    }
  }), _vm._v("\r\n                                                      Okwy Eze\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "mdi mdi-checkbox-blank-circle text-warning"
  }), _vm._v(" Waiting payment")]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      ₦8,541\r\n                                                      "), _c('p', {
    staticClass: "m-0 text-muted font-14"
  }, [_vm._v("Amount")])]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      10/12/2019\r\n                                                      "), _c('p', {
    staticClass: "m-0 text-muted font-14"
  }, [_vm._v("Date")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-secondary btn-sm waves-effect",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    staticClass: "thumb-sm rounded-circle mr-2",
    attrs: {
      "src": "/static/assets/images/users/avatar-4.jpg",
      "alt": "user-image"
    }
  }), _vm._v("\r\n                                                     Katherine Uda\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "mdi mdi-checkbox-blank-circle text-success"
  }), _vm._v(" Confirm")]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      ₦954\r\n                                                      "), _c('p', {
    staticClass: "m-0 text-muted font-14"
  }, [_vm._v("Amount")])]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      8/11/2019\r\n                                                      "), _c('p', {
    staticClass: "m-0 text-muted font-14"
  }, [_vm._v("Date")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-secondary btn-sm waves-effect",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    staticClass: "thumb-sm rounded-circle mr-2",
    attrs: {
      "src": "/static/assets/images/users/avatar-5.jpg",
      "alt": "user-image"
    }
  }), _vm._v("\r\n                                                     Chioma Omaba\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "mdi mdi-checkbox-blank-circle text-danger"
  }), _vm._v(" Payment expired")]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      ₦44,584\r\n                                                      "), _c('p', {
    staticClass: "m-0 text-muted font-14"
  }, [_vm._v("Amount")])]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      7/11/2019\r\n                                                      "), _c('p', {
    staticClass: "m-0 text-muted font-14"
  }, [_vm._v("Date")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-secondary btn-sm waves-effect",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    staticClass: "thumb-sm rounded-circle mr-2",
    attrs: {
      "src": "/static/assets/images/users/avatar-6.jpg",
      "alt": "user-image"
    }
  }), _vm._v("\r\n                                                     Chuks Emeka Ani\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('i', {
    staticClass: "mdi mdi-checkbox-blank-circle text-success"
  }), _vm._v(" Confirm")]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      ₦8,844\r\n                                                      "), _c('p', {
    staticClass: "m-0 text-muted font-14"
  }, [_vm._v("Amount")])]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      1/11/2019\r\n                                                      "), _c('p', {
    staticClass: "m-0 text-muted font-14"
  }, [_vm._v("Date")])]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-secondary btn-sm waves-effect",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Edit")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-6"
  }, [_c('div', {
    staticClass: "card m-b-20"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "mt-0 m-b-30 header-title"
  }, [_vm._v("Latest Orders")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-vertical mb-0"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("#12354781")]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "rounded mr-2",
    staticStyle: {
      "height": "46px"
    },
    attrs: {
      "src": "/static/assets/images/products/1.jpg",
      "alt": "user-image"
    }
  }), _vm._v("\r\n                                                      Product Order\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-pill badge-success"
  }, [_vm._v("Delivered")])]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      ₦185\r\n                                                  ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      5/12/2019\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-secondary btn-sm waves-effect",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("#96254137")]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "rounded mr-2",
    staticStyle: {
      "height": "46px"
    },
    attrs: {
      "src": "/static/assets/images/products/3.jpg",
      "alt": "user-image"
    }
  }), _vm._v("\r\n                                                      Product Order\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-pill badge-danger"
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      ₦657\r\n                                                  ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      5/12/2019\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-secondary btn-sm waves-effect",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("#12365474")]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "rounded mr-2",
    staticStyle: {
      "height": "46px"
    },
    attrs: {
      "src": "/static/assets/images/products/4.jpg",
      "alt": "user-image"
    }
  }), _vm._v("\r\n                                                      Product Order\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-pill badge-warning"
  }, [_vm._v("Shipped")])]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      ₦8451\r\n                                                  ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      5/12/2019\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-secondary btn-sm waves-effect",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Edit")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("#85214796")]), _vm._v(" "), _c('td', [_c('img', {
    staticClass: "rounded mr-2",
    staticStyle: {
      "height": "46px"
    },
    attrs: {
      "src": "/static/assets/images/products/5.jpg",
      "alt": "user-image"
    }
  }), _vm._v("\r\n                                                      Product Order\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "badge badge-pill badge-success"
  }, [_vm._v("Delivered")])]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      ₦584\r\n                                                  ")]), _vm._v(" "), _c('td', [_vm._v("\r\n                                                      5/12/2019\r\n                                                  ")]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-secondary btn-sm waves-effect",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Edit")])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0f90af4"}!./src/pages/Home/template.html
// module id = 264
// module chunks = 0